<template>
  <v-container v-if="paymentOverModal">
    <v-dialog v-model="isSubscritionOverModal" persistent max-width="400px">
      <v-card>
        <v-card-title class="headline"> Confirmation </v-card-title>
        <v-card-text>
          Your payment has expired. To continue using our services without interruption, please
          purchase a plan to continue.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#FE724C" @click="goToSubscriptionPage" style="color: white"
            >Get Subscription</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { computed, watch, ref } from '@vue/composition-api'
import { useRouter } from '@core/utils'
import store from '@/store'
import moment from 'moment'
import { storeGetters } from '@/store/storeConstants'

const { GET_CUSTOMER_SUBSCRIPTION } = storeGetters
export default {
  setup() {
    const subscriptionMode = ref('')
    const isSubscritionOverModal = ref(false)
    const subscription = ref({})
    const { route, router } = useRouter()

    const customerSubscription = computed(
      () => store.getters[`signup/${GET_CUSTOMER_SUBSCRIPTION}`],
    )

    const paymentOverModal = computed(() => {
      const currentTimestamp = moment().unix()
      if (
        (subscriptionMode.value === 'online' &&
          subscription.value?.next_renewal_at < currentTimestamp) ||
        (subscriptionMode.value === 'online' && subscription.value.status === 'canceled')
      ) {
        isSubscritionOverModal.value = true
        return true
      }
      isSubscritionOverModal.value = false
      return false
    })

    const goToSubscriptionPage = () => {
      router.push({ name: 'setup-subscription' })
      isSubscritionOverModal.value = false
    }

    const handleSubscriptionChange = newVal => {
      if (!newVal) return

      subscription.value = newVal?.subscription || {}
      subscriptionMode.value = newVal?.tenant?.subscription_mode

      const customerPayload = {
        price_id: subscription.value?.price_id,
        product_id: subscription.value?.product_id,
        planName: subscription.value?.plan,
        status: subscription.value?.status,
        planTitle: subscription.value?.planName,
      }

      store.commit('signup/SET_PLAN_CONSUMPTION', newVal?.plan_consumption)
      store.commit('signup/SET_CUSTOMER_PAYLOAD', customerPayload)
      store.commit('signup/SET_NEXT_RENEWAL_DATE', subscription.value)

      localStorage.setItem('subscriptionMode', subscriptionMode.value)
      store.commit(
        'signup/SET_IS_BUY_MANUFACTURING_MODULE',
        subscription.value?.addOn?.length === 0,
      )
    }

    watch(customerSubscription, handleSubscriptionChange, {
      immediate: true,
      deep: true,
    })

    return {
      subscriptionMode,
      isSubscritionOverModal,
      subscription,
      paymentOverModal,
      goToSubscriptionPage,
    }
  },
}
</script>
